module.exports = __webpack_public_path__ + "img/线.0e201ecc.svg";